<script>
import { required, email } from "vuelidate/lib/validators";

import {
  authEasyMethods,
  notificationMethods
} from "@/state/helpers";
import { http } from "@/helpers/easyindustriaapi/config";

export default {
  data() {
    return {
      user: { username: "", email: "", password: "", role_id: null },
      rolesList: [],
      submitted: false,
      regError: null,
      tryingToRegister: false,
      isRegisterError: false,
      registerSuccess: false,
      currentEmpresa: null,
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    }
  },
  validations: {
    user: {
      username: { required },
      email: { required, email },
      password: { required }
    }
  },
  created() {
    document.body.classList.add("auth-body-bg");
	this.currentEmpresa = JSON.parse(localStorage.getItem('currentEmpresa'));
    this.loadRoles();
  },
  methods: {
    ...authEasyMethods,
    ...notificationMethods,
    async loadRoles() {
      try {
        const response = await http.get('/user/roles');
        const roles = response.data && response.data.data ? response.data.data.roles : [];
        this.rolesList = (roles || []).filter(role => role.name !== 'super').map(role => ({ text: role.description, value: role.id }));
      } catch (error) { this.rolesList = []; }
    },
    // Try to register the user in with the email, username
    // and password they provided.
    tryToRegisterIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          this.tryingToRegister = true;
          // Reset the regError if it existed.
          this.regError = null;
          return (
            this.registerUser({
              name: this.user.username,
              email: this.user.email,
              password: this.user.password,
              empresa_id: this.currentEmpresa.id,
              role_id: this.user.role_id
            })
              // eslint-disable-next-line no-unused-vars
              .then(token => {
                this.tryingToRegister = false;
                this.isRegisterError = false;
                this.registerSuccess = true;
                if (this.registerSuccess) {
                  this.$router.push(
                    this.$route.query.redirectFrom || { name: "home" }
                  );
                }
              })
              .catch(error => {
                this.tryingToRegister = false;
                this.regError = error ? error : "";
                this.isRegisterError = true;
              })
          );
        } else {
          if (process.env.VUE_APP_DEFAULT_AUTH === "easyindustria-api") {
            this.tryingToRegister = true;
            // Reset the regError if it existed.
            this.regError = null;
            return (
              this.registerUser({
                name    : this.user.username,
                email   : this.user.email,
                password: this.user.password,
                empresa_id: this.currentEmpresa.id,
                role_id: this.user.role_id
              })
                // eslint-disable-next-line no-unused-vars
                .then(token => {
                  this.tryingToRegister = false;
                  this.isRegisterError = false;
                  this.registerSuccess = true;
                  if (this.registerSuccess) {
                    this.$router.push(
                      this.$route.query.redirectFrom || { name: "home" }
                    );
                  }
                })
                .catch(error => {
                  this.tryingToRegister = false;
                  this.regError = error ? error : "";
                  this.isRegisterError = true;
                })
            );
          }else {
            const { email, username, password } = this.user;
            if (email && username && password) {
              this.registeruser(this.user);
            }
          }
        }
      }
    }
  }
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div>
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-4">
            <div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div class="w-100">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <div class="text-center">
                        <div>
                          <a href="/" class="logo">
                            <img src="@/assets/images/logo.png" height="20" alt="logo" />
                          </a>
                        </div>

                        <h4 class="font-size-18 mt-4">Criar conta</h4>
                        <p class="text-muted">Crie agora uma conta no EasyIndustria Web.</p>
                      </div>

                      <div class="p-2 mt-5">
                        <b-alert
                          v-model="registerSuccess"
                          class="mt-3"
                          variant="success"
                          dismissible
                        >Cadastro realizado com sucesso.</b-alert>

                        <b-alert
                          v-model="isRegisterError"
                          class="mt-3"
                          variant="danger"
                          dismissible
                        >{{regError}}</b-alert>

                        <b-alert
                          variant="danger"
                          class="mt-3"
                          v-if="notification.message"
                          show
                          dismissible
                        >{{notification.message}}</b-alert>
                        
                        <form class="form-horizontal" @submit.prevent="tryToRegisterIn">
                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-user-2-line auti-custom-input-icon"></i>
                            <label for="username">Nome de usuário</label>
                            <input
                              v-model="user.username"
                              type="text"
                              class="form-control"
                              id="username"
                              :class="{ 'is-invalid': submitted && $v.user.username.$error }"
                              placeholder="Digite um login (nome de usuário)"
                            />
                            <div
                              v-if="submitted && !$v.user.username.required"
                              class="invalid-feedback"
                            >Nome de usuário obrigatório.</div>
                          </div>

                          <div class="form-group mb-4">
                            <label for="userrole">Perfil</label>
                            <select id="userrole" v-model="user.role_id" class="form-control" required>
                              <option :value="null">Selecione um perfil</option>
                              <option v-for="role in rolesList" :key="role.value" :value="role.value">{{ role.text }}</option>
                            </select>
                          </div>

                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-mail-line auti-custom-input-icon"></i>
                            <label for="useremail">E-mail</label>
                            <input
                              v-model="user.email"
                              type="email"
                              class="form-control"
                              id="useremail"
                              placeholder="Digite seu e-mail"
                              :class="{ 'is-invalid': submitted && $v.user.email.$error }"
                            />
                            <div v-if="submitted && $v.user.email.$error" class="invalid-feedback">
                              <span v-if="!$v.user.email.required">E-mail obrigatório.</span>
                              <span v-if="!$v.user.email.email">Digite um e-mail válido.</span>
                            </div>
                          </div>

                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-lock-2-line auti-custom-input-icon"></i>
                            <label for="userpassword">Senha</label>
                            <input
                              v-model="user.password"
                              type="password"
                              class="form-control"
                              id="userpassword"
                              placeholder="Digite uma senha"
                              :class="{ 'is-invalid': submitted && $v.user.password.$error }"
                            />
                            <div
                              v-if="submitted && !$v.user.password.required"
                              class="invalid-feedback"
                        >Campo obrigatório.</div>
                          </div>

                          <div class="text-center">
                            <button
                              class="btn btn-primary w-md waves-effect waves-light"
                              type="submit"
                            >Gravar</button>
                          </div>
                        </form>
                      </div>

                      <div class="mt-5 text-center">
                        <p>
                          Já tem uma conta ?
                          <router-link
                            tag="a"
                            to="/login"
                            class="font-weight-medium text-primary"
                          >Entrar</router-link>
                        </p>
                        <p>
                          © 2021 EasyIndustria Web 1.0.
                          <i class="mdi mdi-heart text-danger"></i> por SiD Soluções
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="authentication-bg">
              <div class="bg-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
